import { render, staticRenderFns } from "./makeSeal.vue?vue&type=template&id=45aa856c&scoped=true"
import script from "./makeSeal.vue?vue&type=script&lang=js"
export * from "./makeSeal.vue?vue&type=script&lang=js"
import style0 from "./makeSeal.vue?vue&type=style&index=0&id=45aa856c&prod&lang=less"
import style1 from "./makeSeal.vue?vue&type=style&index=1&id=45aa856c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa856c",
  null
  
)

export default component.exports